export class QuestionnaireModel {
  constructor(
        readonly code : string,
        readonly text: string) {
  }
}


// WEBPACK FOOTER //
// ./src/app/models/questionnaire-model.ts